import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import { Icon } from '@mui/material';
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function ModalComponent({ open, onClose, item, handleRefresh }) {
    const AppService = useAppServices();
    const [agency] = useAgencyInfo();
    const [waiting, setWaiting] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    useEffect(() => {
        if (item?.category && Array.isArray(item.category)) {
            // Find category for current agency
            const existing = item.category.find(cat => cat.agency_id === agency._id);
            if (existing) {
                setSelectedCategory(existing);
            } else {
                setSelectedCategory(null);
            }
        } else if (item?.category?.id) {
            // Handle legacy single category object
            const existing = agency?.Categories?.find(cat => cat.id === item.category.id);
            if (existing) {
                const categoryWithAgencyId = {
                    ...existing,
                    agency_id: agency._id
                };
                setSelectedCategory(categoryWithAgencyId);
            } else {
                setSelectedCategory(null);
            }
        }
    }, [item?.category, agency?.Categories, agency._id]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setWaiting(true);

        // Add agency_id to the selected category
        const categoryWithAgencyId = {
            ...selectedCategory,
            agency_id: agency._id
        };

        // Handle category as array - update or add category for current agency
        let updatedCategories = [];
        
        if (item?.category && Array.isArray(item.category)) {
            // Remove existing category for this agency and add new one
            updatedCategories = item.category.filter(cat => cat.agency_id !== agency._id);
            if (selectedCategory) {
                updatedCategories.push(categoryWithAgencyId);
            }
        } else {
            // Initialize as array with current agency's category
            updatedCategories = selectedCategory ? [categoryWithAgencyId] : [];
        }

        const payload = {
            _id: item._id,
            category: updatedCategories, // Array of category objects: [{ id, name, color, agency_id }, ...]
        };

        const newAssistant = await AppService.assistant.update({ payload, toaster: true });
        if (newAssistant) {
            handleRefresh();
            onClose();
        }
        setWaiting(false);
    };

    return (
        <>
            {open && (
                <div className="modal-zz-confirm text-left">
                    <div className="p-2 scrollable-modal-content bg-white rounded" style={{ position: "relative" }}>
                        <h2 className='text-black text-left font-14' style={{ fontWeight: "700", marginBottom: '10px' }}>
                            Edit Agent Category
                        </h2>
                        <span className='crossison' onClick={onClose}>X</span>

                        <SoftBox component="form" onSubmit={handleSubmit}>

                            <label className="mb-1">Category</label>
                            <select
                                style={{ width: "100%", padding: "12px", borderRadius: "4px", border: "1px solid #ccc" }}
                                value={selectedCategory?.id || ''}
                                onChange={e => {
                                    const cat = agency?.Categories.find(cat => cat.id === e.target.value);
                                    if (cat) {
                                        // Ensure agency_id is included in the selected category
                                        const categoryWithAgencyId = {
                                            ...cat,
                                            agency_id: agency._id
                                        };
                                        setSelectedCategory(categoryWithAgencyId);
                                    } else {
                                        setSelectedCategory(null);
                                    }
                                }}
                            >
                                <option value="">Select Category</option>
                                {agency?.Categories?.map((category) => (
                                    <option key={category.id} value={category.id}>
                                        {category.name}
                                    </option>
                                ))}
                            </select>

                            <SoftBox mt={2}>
                                <button className="savebtn-setting w-100" type="submit" disabled={waiting || !selectedCategory}>
                                    {waiting && (
                                        <div className="spinner" style={{
                                            width: '16px',
                                            height: '16px',
                                            display: "inline-block",
                                            marginRight: "8px"
                                        }}></div>
                                    )}
                                    Edit Agent Category
                                </button>
                            </SoftBox>

                        </SoftBox>
                    </div>
                </div>
            )}
        </>
    );
}

ModalComponent.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    handleRefresh: PropTypes.func.isRequired,
};

function AddCategory({ item, handleRefresh }) {
    const [openAddMember, setOpenAddMember] = useState(false);

    return (
        <>
            <span style={{cursor:'pointer'}} onClick={() => setOpenAddMember(true)}><Icon>edit</Icon></span>

            <ModalComponent
                open={openAddMember}
                onClose={() => setOpenAddMember(false)}
                item={item}
                handleRefresh={handleRefresh}
            />
        </>
    );
}

AddCategory.propTypes = {
    item: PropTypes.object.isRequired,
    handleRefresh: PropTypes.func.isRequired,
};

export default AddCategory;
